import { ca } from '@cian/analytics';
import { IJsonQuery } from '../../types/jsonQuery/jsonQuery';
import { TProduct } from '../../types/product';

interface IPromoDetailsClickParams {
  product: TProduct;
  sc: IJsonQuery;
}

/**
 * Отправка события клика на подробности акции
 * https://conf.cian.tech/pages/viewpage.action?pageId=1311539818
 * @param {IPromoDetailsClickParams} params - Параметры события
 */
export const trackPromoDetailsClick = (params: IPromoDetailsClickParams, isFromBank: boolean) => {
  const { product, sc } = params;

  ca('eventSite', {
    action: 'Click',
    category: 'Promo',
    label: 'Details',
    name: 'oldevent',
    products: [product],
    page: {
      extra: {
        is_bank_mortgage: isFromBank,
      },
    },
    sc,
  });
};
